module.exports = __webpack_public_path__ + "img/img_85.3e3dd585.png";